if (!customElements.get('pn-video-carousel')) {
  customElements.define('pn-video-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-video-track]');
      this.cards = Array.from(this.querySelectorAll('[data-video-card]'));
      if (!this.track || !this.cards.length) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous = this.querySelector('[data-video-prev]');
      this.next = this.querySelector('[data-video-next]');
      this.arrows = this.querySelector('[data-video-arrows]');
      this.progress = this.querySelector('[data-video-progress]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.previous?.addEventListener('click', () => this.move(-1), options);
      this.next?.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { passive: true, signal: this.controller.signal });
      document.addEventListener('shopify:block:select', event => {
        const card = this.cards.find(item => item.dataset.blockId === event.detail?.blockId);
        if (!card) return;
        this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: 'auto' });
        this.update();
      }, options);

      if (this.arrows) this.arrows.hidden = false;
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }

    move(direction) {
      const first = this.cards[0];
      if (!first) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = first.getBoundingClientRect().width + gap;
      this.track.scrollBy({ left: direction * step, behavior: this.motion.matches ? 'auto' : 'smooth' });
    }

    update() {
      if (!this.track) return;
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const progress = maxScroll > 0 ? Math.min(1, Math.max(0, this.track.scrollLeft / maxScroll)) : 0;
      const width = this.track.scrollWidth > 0 ? Math.min(1, this.track.clientWidth / this.track.scrollWidth) : 1;
      if (this.progress) {
        this.progress.style.width = `${width * 100}%`;
        this.progress.style.left = `${progress * (1 - width) * 100}%`;
      }
      if (this.previous) this.previous.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= maxScroll - 2;
    }
  });
}
